import parsePhoneNumber from 'libphonenumber-js';

const contactPhoneNumber = parsePhoneNumber('+18564859703')!;

export const CONTACT_INTERNATIONAL_PHONE_NUMBER = contactPhoneNumber.formatInternational(); // +1 856 485 9703
export const CONTACT_NATIONAL_PHONE_NUMBER = contactPhoneNumber.formatNational(); // (856) 485-9703
export const CONTACT_URI_PHONE_NUMBER = contactPhoneNumber.getURI(); // tel:+18564859703

const marketingSupportPhoneNumber = parsePhoneNumber('+19294332348')!;

export const MARKETING_SUPPORT_PHONE_NUMBER_DISPLAY = marketingSupportPhoneNumber.formatInternational(); // +1 929 433 2348
export const MARKETING_SUPPORT_PHONE_NUMBER_URI = marketingSupportPhoneNumber.getURI(); // tel:+19294332348
export const SUPPORT_URL = 'https://www.metropolis.io/support';
export const TERMS_OF_SERVICE_URL = 'https://metropolis.io/terms/';
export const PRIVACY_POLICY_URL = 'https://metropolis.io/privacy/';
export const PRODUCT_SUPPORT_TICKET_LINK =
  'https://metropolisio.atlassian.net/servicedesk/customer/portal/56';

export const SMS_PHONE_NUMBER = '676547';

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/metropolis-remarkable-parking/id1556970037';

// Site group-specific (Location) phone number overrides for exit displays.
// Maps siteGroupId to local office phone numbers.
const SITE_GROUP_PHONE_NUMBER_OVERRIDES: Record<number, string> = {
  588: '+16156783628', // Target Westwood
  2546: '+12102073490', // SAT - San Antonio International Airport
  2608: '+17175394768', // BLVD Las Vegas
  3047: '+19477292402', // ASE - Bear Lot
  3133: '+14792051119', // XNA - Northwest Arkansas National Airport
  3139: '+19373586461', // ASE - Elk Lot
  3824: '+12543183460', // Westland Ave Garage
  3837: '+13015672277', // Spirit Lot
  3843: '+19157717990', // ELP - El Paso International Airport
  3890: '+17075835130', // Sonoma Airport
  3904: '+12056561338', // CAK - Akron-Canton Airport Economy Lot
  3961: '+15592520052', // FAT - Fresno Yosemite International Airport
};

// Site-specific (Zone) phone number overrides for exit displays.
// Maps siteId to local office phone numbers. A zone override takes precedence
// over its location's override, so individual zones that share a single
// Location (site group) can present their own local phone number.
const SITE_ZONE_PHONE_NUMBER_OVERRIDES: Record<number, string> = {
  2928: '+12183193087', // BIL - Billings Logan International Airport (Zone 2928)
  4700: '+12603344622', // BIL - Billings Logan International Airport (Zone 4700)
  4703: '+14322802122', // BIL - Billings Logan International Airport (Zone 4703)
  4704: '+12183256975', // BIL - Billings Logan International Airport (Zone 4704)
};

const formatContactPhoneNumber = (rawPhoneNumber: string) => {
  const phoneNumber = parsePhoneNumber(rawPhoneNumber);
  if (!phoneNumber) {
    return undefined;
  }
  return {
    international: phoneNumber.formatInternational(),
    national: phoneNumber.formatNational(),
    uri: phoneNumber.getURI(),
  };
};

/**
 * Get the appropriate contact phone number for an exit display.
 *
 * Precedence:
 *   1. Site (Zone) override, if one is configured for the siteId.
 *   2. Site group (Location) override, if one is configured for the siteGroupId.
 *   3. Default Metropolis support number.
 *
 * A zone-level override always wins over its location so individual zones that
 * share a single location can present their own local phone number.
 */
export const getContactPhoneNumber = (siteId?: number, siteGroupId?: number) => {
  const override =
    (siteId ? SITE_ZONE_PHONE_NUMBER_OVERRIDES[siteId] : undefined) ??
    (siteGroupId ? SITE_GROUP_PHONE_NUMBER_OVERRIDES[siteGroupId] : undefined);

  if (override) {
    const formatted = formatContactPhoneNumber(override);
    if (formatted) {
      return formatted;
    }
  }

  return {
    international: CONTACT_INTERNATIONAL_PHONE_NUMBER,
    national: CONTACT_NATIONAL_PHONE_NUMBER,
    uri: CONTACT_URI_PHONE_NUMBER,
  };
};
